'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePicker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react2 = require("../..");

require("@zebra-fed/icons/Navigation/index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  text-align: center;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n  height: ", ";\n  color: ", ";\n  background-color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  font-weight: bold;\n  font-family: ", ";\n  background-color: ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: bold;\n  font-family: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  width: 100%;\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: ", ";\n  font-weight: bold;\n  font-family: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MiddleContainer = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.spacingObj.midContainerHeight + 'px';
}, function (props) {
  return props.colorObj.whiteBackground;
}, function (props) {
  return props.colorObj.blueText;
}, function (props) {
  return props.spacingObj.fontSize + 'px';
}, function (props) {
  return props.fontFamilyObj;
});

var TimeContainer = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.spacingObj.width + 'px';
}, function (props) {
  return props.spacingObj.height + 'px';
}, function (props) {
  return props.colorObj.backgroundColor;
}, function (props) {
  return props.colorObj.textColor;
}, function (props) {
  return props.spacingObj.fontSize + 'px';
}, function (props) {
  return props.fontFamilyObj;
});

var TimeSquare = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.spacingObj.height + 'px';
}, function (props) {
  return props.spacingObj.height + 'px';
}, function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.colorObj.offwhiteBackground;
});

var ButtonContainer = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.spacingObj.height + 'px';
}, function (props) {
  return props.colorObj.blueText;
}, function (props) {
  return props.colorObj.whiteBackground;
});

var Controls = _styledComponents["default"].div(_templateObject5(), function (props) {
  return props.spacingObj.midContainerHeight + 'px';
}, function (props) {
  return props.spacingObj.height + 'px';
});

var StyedDiv = _styledComponents["default"].div(_templateObject6(), function (props) {
  return props.spacingObj.spacer + 'px';
});
/**
 * TimePickers are designed to set time.
 * @example import { TimePicker } from @desktop/react;
 */


var TimePicker = function TimePicker(props) {
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var colors = context.getColors()[props.inherit];
  var spacing = context.getSpacing()[props.inherit];

  var _useState = (0, _react.useState)(props.hour),
      _useState2 = _slicedToArray(_useState, 2),
      hours = _useState2[0],
      setHours = _useState2[1];

  var _useState3 = (0, _react.useState)(props.minute),
      _useState4 = _slicedToArray(_useState3, 2),
      minutes = _useState4[0],
      setMinutes = _useState4[1];

  var increment = function increment(type) {
    if (type === 'hours') {
      if (hours < 23) {
        setHours(hours + 1);
      } else {
        setHours(0);
      }
    } else {
      if (minutes < 59) {
        setMinutes(minutes + 1);
      } else {
        setMinutes(0);
        setHours(hours + 1);
      }
    }
  };

  var decrement = function decrement(type) {
    if (type === 'hours') {
      if (hours > 0) {
        setHours(hours - 1);
      } else if (hours === 0) {
        setHours(24);
      }
    } else {
      if (minutes > 0) {
        setMinutes(minutes - 1);
      } else if (minutes === 0) {
        setMinutes(59);
        setHours(hours - 1);
      }
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement(TimeContainer, {
    timeContainerStyle: props.timeContainerStyle,
    spacingObj: spacing,
    colorObj: colors,
    fontFamilyObj: context.getFont()
  }, hours > 9 ? hours : "0".concat(hours), ":", minutes > 9 ? minutes : "0".concat(minutes)), /*#__PURE__*/_react["default"].createElement(MiddleContainer, {
    spacingObj: spacing,
    colorObj: colors,
    fontFamilyObj: context.getFont()
  }, /*#__PURE__*/_react["default"].createElement(Controls, {
    spacingObj: spacing,
    colorObj: colors
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    name: 'up',
    category: 'navigation',
    color: '#8E8E8E',
    onClick: function onClick() {
      return increment('hours');
    }
  }), /*#__PURE__*/_react["default"].createElement(TimeSquare, {
    spacingObj: spacing,
    colorObj: colors
  }, hours > 9 ? hours : "0".concat(hours)), /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    name: 'down',
    category: 'navigation',
    color: '#8E8E8E',
    onClick: function onClick() {
      return decrement('hours');
    }
  })), /*#__PURE__*/_react["default"].createElement(StyedDiv, {
    spacingObj: spacing
  }, ":"), /*#__PURE__*/_react["default"].createElement(Controls, {
    spacingObj: spacing,
    colorObj: colors,
    fontFamilyObj: context.getFont()
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    name: 'up',
    category: 'navigation',
    color: '#8E8E8E',
    onClick: function onClick() {
      return increment('minutes');
    }
  }), /*#__PURE__*/_react["default"].createElement(TimeSquare, {
    spacingObj: spacing,
    colorObj: colors,
    fontFamilyObj: context.getFont()
  }, minutes > 9 ? minutes : "0".concat(minutes)), /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    name: 'down',
    category: 'navigation',
    color: '#8E8E8E',
    onClick: function onClick() {
      return decrement('minutes');
    }
  }))), /*#__PURE__*/_react["default"].createElement(ButtonContainer, {
    spacingObj: spacing,
    colorObj: colors
  }, /*#__PURE__*/_react["default"].createElement(_react2.Button, {
    style: {
      color: '#007ABA',
      fontWeight: 'bold'
    },
    onClick: function onClick() {
      return props.onCancel();
    }
  }, "CANCEL"), /*#__PURE__*/_react["default"].createElement(_react2.Button, {
    style: {
      color: '#007ABA',
      fontWeight: 'bold'
    },
    onClick: function onClick() {
      return props.onSubmit();
    }
  }, "OK")));
};

exports.TimePicker = TimePicker;
TimePicker.propTypes = {
  /**Recieves a number to set initail hours state. */
  hour: _propTypes["default"].number,

  /**Recieves a number to set initail minutes state. */
  minute: _propTypes["default"].number,

  /**Extends the base styling of the time picker element. */
  style: _propTypes["default"].object,

  /**The callback function fired when the OK button is clicked. */
  onSubmit: _propTypes["default"].func,

  /**The callback function fired when the CANCEL button is clicked. */
  onCancel: _propTypes["default"].func
};
TimePicker.defaultProps = {
  inherit: 'timepicker',
  hour: 0,
  minute: 0,
  style: {},
  onSubmit: function onSubmit() {
    return false;
  },
  onCancel: function onCancel() {
    return false;
  }
};